export default {
  title: 'Create your App',
  description:
    'Build your app on top of Remix SaaS, explore the documentation and start your journey.',
}
